module.exports = __webpack_public_path__ + "static/media/veg_pizza.379bb776.jpeg";